



export  async function apiPost(url,data){

    console.log("Inside apiPost "+url)
    
    
    // const storedToken = sessionStorage.getItem('TOKEN');
    // console.log(storedToken);

    const options = {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      // mode:'no-cors', 
      // headers: { 'Content-Type': 'text/plain'},
      headers: {'Authorization': 'Bearer ' + sessionStorage.getItem('TOKEN')},
      body: JSON.stringify(data),
    };
    console.log(JSON.stringify(data))

    return await fetch(url,options);
   
}

export async function apiPut(url, data, contentType){
  var head 
//  head =  {'Content-Type': contentType, 'Authorization': 'Bearer ' + sessionStorage.getItem('TOKEN')}
  head =  {'Content-Type': contentType}
  
  const options = {
    method: 'PUT', // *GET, POST, PUT, DELETE, etc.
    headers: head,
    body: data
  };
  var retData = {};

  await fetch(url,options)
  .then(async response => {
    const data = await(response.text())
    if(response.ok){
      console.dir(response);
      console.log(retData);
      return data;
    }
    else { 
      console.log("Received no response from server");
      alert("Failed to upload files");
      // throw "Received no response from server";
    }
      
  })
  .catch((err)=> {
    alert(err);
    console.log(err.message);
      throw err;
  });

}



// export async function apiGet(url){
//   console.log("Inside apiGet :"+ url)
//   var retData = {};
//   await fetch(url)
//     .then(( response)=> {
//       // const data = await(response.text())
//       // retData = data.slice()
//       if(response.ok){
//         console.log("apiGet response is ok");
//         retData = response.json();
//         console.log("response from " + url)
//         console.log(retData)
//         }
//       else { 
//         console.log("Received no response from server");
//         //alert("Failed to Get");
//         throw new Error("Received no response from server");
//       }
        
//     })
//     .catch((err)=> {
//         // alert(err);
//         console.log(err.message);
//         throw err;
//     });
//   return retData


// }


export async function apiGet(url){
  console.log(`apiGet ${url}`)
  // const storedToken = sessionStorage.getItem('TOKEN');
  // console.log(storedToken);
  const options = {
    method: 'GET',
    headers: {'Authorization': 'Bearer ' + sessionStorage.getItem('TOKEN')},
  };
  const response = await fetch(url,options);
  return response.json();
}


export async function apiDel(url,data){

}

// export async function apiPut(url,data){

// }